<div class="results-section">
  @if (results().length > 0) {
    <mat-accordion multi class="results-section__accordion">
      @for (result of results(); track result.nnnResultDbRef) {
        <mat-expansion-panel class="result-panel">
          <mat-expansion-panel-header class="result-panel__header">
            <mat-panel-title class="result-panel__title">
              @if (zorgresultaat(result); as summary) {
                <span class="result-panel__badge">{{ summary.code }}</span>
                <span class="result-panel__label" [matTooltip]="summary.omschrijving" matTooltipClass="card-tooltip">
                  {{ summary.omschrijving }}
                </span>
              } @else {
                <span class="result-panel__label">{{ result.nnnResultDbRef }}</span>
              }
              @if (resultScoreSummary(result); as scores) {
                <span
                  class="result-panel__scores"
                  [matTooltip]="resultScoreTooltip(result)"
                  matTooltipClass="score-tooltip"
                  (click)="$event.stopPropagation()">
                  @if (scores.current !== null) {
                    <span>{{ scores.current }}</span>
                  }
                  @if (scores.desired !== null) {
                    <mat-icon class="result-panel__scores-arrow">arrow_forward</mat-icon>
                    <span>{{ scores.desired }}</span>
                  }
                </span>
              }
            </mat-panel-title>
          </mat-expansion-panel-header>
          @if (result.indicators.length > 0) {
            <ul class="result-panel__indicators">
              @for (indicator of result.indicators; track indicator.nnnIndicatorDbRef) {
                <li class="result-panel__indicator">
                  <span class="result-panel__indicator-name">{{ indicatorLabel(indicator.nnnIndicatorDbRef) }}</span>
                  @if (indicatorScoreSummary(indicator); as scores) {
                    <span
                      class="result-panel__scores result-panel__scores--indicator"
                      [matTooltip]="indicatorScoreTooltip(indicator)"
                      matTooltipClass="score-tooltip">
                      @if (scores.current !== null) {
                        <span>{{ scores.current }}</span>
                      }
                      @if (scores.desired !== null) {
                        <mat-icon class="result-panel__scores-arrow">arrow_forward</mat-icon>
                        <span>{{ scores.desired }}</span>
                      }
                    </span>
                  }
                </li>
              }
            </ul>
          } @else {
            <p class="result-panel__no-indicators">
              {{ 'epd.functions.careplan-nnn.results-section.no-indicators' | translate | capitalize }}
            </p>
          }
          <app-nnn-notes-cell
            labelKey="epd.functions.careplan-nnn.results-section.notes"
            [value]="result.notes"
            [disabled]="!editable()"
            [showCounter]="editable()"
            (valueInput)="onNotesInput(result, $event)"
            (save)="saveNotes()"></app-nnn-notes-cell>
          @if (editable()) {
            <div class="result-panel__actions">
              <button
                mat-icon-button
                type="button"
                class="result-panel__action result-panel__action--info"
                (click)="openInfo()"
                matTooltip="{{ 'epd.functions.careplan-nnn.results-section.info-button' | translate | capitalize }}"
                matTooltipClass="card-tooltip">
                <mat-icon>info_outline</mat-icon>
              </button>
              <button
                mat-icon-button
                class="result-panel__action result-panel__action--edit"
                [disabled]="!zorgresultaat(result)"
                (click)="openEdit(result)"
                matTooltip="{{ 'general.actions.edit' | translate | capitalize }}"
                matTooltipClass="card-tooltip">
                <mat-icon>edit</mat-icon>
              </button>
              <button
                mat-icon-button
                class="result-panel__action result-panel__action--delete"
                (click)="remove(result)"
                matTooltip="{{ 'general.actions.delete' | translate | capitalize }}"
                matTooltipClass="card-tooltip">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          }
        </mat-expansion-panel>
      }
    </mat-accordion>
  }
  @if (editable()) {
    <button mat-button color="primary" class="results-section__add" (click)="openAdd()">
      <mat-icon>add</mat-icon>
      {{ 'epd.functions.careplan-nnn.results-section.add' | translate | capitalize }}
    </button>
  }
  @if (editable()) {
    <div class="results-section__save-state">
      @if (saveState() === 'saving') {
        <span>{{ 'general.actions.saving' | translate }}</span>
      } @else if (saveState() === 'saved') {
        <span class="results-section__save-state--saved">{{ 'general.words.saved' | translate }}</span>
      }
    </div>
  }
</div>
